import { useState, useEffect } from "react";

import { executeTransfert, searchDocuments, getListeTiers } from "./Services/transfertService";
import TransfertDetailModal from "./TransfertDetailModal";
import TransfertFilters from "./TransfertFilters";
import TransfertFooter from "./TransfertFooter";
import TransfertTable from "./TransfertTable";
import useTransfertPanier from "./Hooks/useTransfertPanier";
import dayjs from 'dayjs';
import Swal from "sweetalert2";


const DocumentTransfertPage = ({ mode }) => {

  const [filters, setFilters] = useState({});
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [sourceType, setSourceType] = useState("");
  const [destinationType, setDestinationType] = useState("");
  const [errors, setErrors] = useState({});
  const [errorsTransfert, setErrorsTransfert] = useState({});
  const [tiers, setTiers] = useState([]);
  const { panier, saveDocument, clearPanier } = useTransfertPanier();

  const nbDocuments = panier.filter(d => d.lignes && d.lignes.length > 0).length;
  const nbLignes = panier.reduce((total, doc) => {
    return total + doc.lignes.length;
  }, 0);

  const sourceTypes =
    mode === "achat"
      ? [
        { text: "Demande d'achat", value: "DemandeAchat" },
        { text: "Bon de commande", value: "BonCommandeAchat" },
        { text: "Bon de réception", value: "BonReception" },
        { text: "Facture achat", value: "FactureAchat" }
      ]
      : [
        { text: "Devis", value: "DevisVente" },
        { text: "Bon de commande", value: "BonCommandeVente" },
        { text: "Bon de livraison", value: "BonLivraison" },
        { text: "Facture", value: "Facture" }
      ];

  const destinationTypes = sourceTypes;

  useEffect(() => {
    const fetchTiers = async () => {
      const response = await getListeTiers(mode);
      setTiers(Object.values(response.data)); // <- transformation en tableau
    };

    fetchTiers();
  }, []);

  useEffect(() => {
    console.log("Panier updated:", panier);
  }, [panier]);

  const handleSearch = async () => {
    const newErrors = {};

    if (!filters.type) {
      newErrors.type = "Le type document est obligatoire";
    }
    if (!filters.idTiers) {
      newErrors.type = "Le tiers est obligatoire";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0)
      return;
    const cleanedFilters = {
      ...filters,
      dateDebut: filters.dateDebut || null,
      dateFin: filters.dateFin || null,
      numero: filters.numero || null,
      type: filters.type || null,
      idTiers: filters.idTiers ? filters.idTiers : null
    };
    console.log("cleanedFilters", cleanedFilters);
    setLoading(true);

    const res = await searchDocuments(cleanedFilters);

    const formattedData = res.data.map(item => ({
      ...item,
      dateDocument: dayjs(item.dateDocument).format('DD/MM/YYYY')
    }));
    console.log("After call searchDocuments", documents);
    setDocuments(formattedData);
    setSourceType(filters.type);
    setLoading(false);
  };
  const handleTransfert = async () => {

    const newErrors = {};
    if (!destinationType) {
      newErrors.type = "Le type destination est obligatoire";
    }
    setErrorsTransfert(newErrors);
    if (panier.length === 0) Swal.fire("Erreur", "Veuillez sélectionner au moins un document.", "warning");
    if (Object.keys(newErrors).length > 0)
      return;
    // Vérifier les quantités de toutes les lignes
    const ligneInvalide = panier
      .flatMap(doc => doc.lignes || [])
      .find(ligne => Number(ligne.quantite) <= 0);

    if (ligneInvalide) {
      Swal.fire(
        "Transfert impossible",
        `Toutes les quantités à transférer doivent être supérieures à 0.`,
        "warning"
      );
      return;
    }
    const payload = {
      destinationDocumentType: destinationType,
      sourceType: sourceType,
      documents: panier
    };
    try {
      await executeTransfert(payload);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Transfert effectué avec succès !",
        showConfirmButton: false,
        timer: 2000
      });


      clearPanier();
    } catch (error) {

      Swal.fire(
        "Transfert impossible",
        error.response?.data?.message || "Une erreur est survenue.",
        "warning"
      );
    }
  };

  return (
    <>
      <TransfertFilters
        filters={filters}
        mode={mode}
        sourceTypes={sourceTypes}
        sourceTiers={tiers}
        errors={errors}
        setFilters={setFilters}
        onSearch={handleSearch}
      />
      <div className="alert alert-info">
        🛒 Panier transfert : <b>{nbDocuments}</b> documents | <b>{nbLignes}</b> lignes
      </div>
      <TransfertTable
        mode={mode}
        documents={documents}
        panier={panier}
        loading={loading}
        onDetail={setSelectedDocument}
      />

      <TransfertDetailModal
        document={selectedDocument}
        panier={panier}
        sourceType={sourceType}
        onClose={() => setSelectedDocument(null)}
        onSave={(doc) => saveDocument(doc)}
      />

      <TransfertFooter
        destinationType={destinationType}
        destinationTypes={destinationTypes}
        errors={errorsTransfert}
        setDestinationType={setDestinationType}
        onTransfert={handleTransfert}
        disabled={!panier.length}
      />
    </>
  );
};

export default DocumentTransfertPage;
